import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoaderWhite = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("circle", {
			fill: "#ffffff",
			cx: 12,
			cy: 2.5,
			r: 1.5,
			opacity: .14
		}),
		/* @__PURE__ */ _jsx("circle", {
			fill: "#ffffff",
			cx: 16.75,
			cy: 3.77,
			r: 1.5,
			opacity: .29
		}),
		/* @__PURE__ */ _jsx("circle", {
			fill: "#ffffff",
			cx: 20.23,
			cy: 7.25,
			r: 1.5,
			opacity: .43
		}),
		/* @__PURE__ */ _jsx("circle", {
			fill: "#ffffff",
			cx: 21.5,
			cy: 12,
			r: 1.5,
			opacity: .57
		}),
		/* @__PURE__ */ _jsx("circle", {
			fill: "#ffffff",
			cx: 20.23,
			cy: 16.75,
			r: 1.5,
			opacity: .71
		}),
		/* @__PURE__ */ _jsx("circle", {
			fill: "#ffffff",
			cx: 16.75,
			cy: 20.23,
			r: 1.5,
			opacity: .86
		}),
		/* @__PURE__ */ _jsx("circle", {
			fill: "#ffffff",
			cx: 12,
			cy: 21.5,
			r: 1.5
		})
	] })
});
export default SvgLoaderWhite;
